import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { USER_QUERIES, UserQueries } from '@/app/platform/platform-core/user/store/types';

@Injectable({
  providedIn: 'root'
})
export class BlockIfAuthenticatedGuard  {
  constructor(
    @Inject(USER_QUERIES)
    private readonly userQueries: UserQueries,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.doRedirect) {
      this.router.navigate(['/']);
    }

    return !this.userQueries.getIsAnyUserAuthenticated();
  }

  get doRedirect(): boolean {
    return this.userQueries.getIsAnyUserAuthenticated();
  }
}
